"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconArrowUpCircleFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM7.29283 3.29289C7.68336 2.90237 8.31652 2.90237 8.70705 3.29289L11.707 6.29289C12.0976 6.68342 12.0976 7.31658 11.707 7.70711C11.3165 8.09763 10.6834 8.09763 10.2928 7.70711L9.0004 6.41467V12C9.0004 12.5523 8.55268 13 8.0004 13C7.44811 13 7.0004 12.5523 7.0004 12V6.41376L5.70705 7.70711C5.31652 8.09763 4.68336 8.09763 4.29283 7.70711C3.90231 7.31658 3.90231 6.68342 4.29283 6.29289L7.29283 3.29289Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M18.9998 9.99999C18.9998 14.9706 14.9704 19 9.99982 19C5.02925 19 0.999817 14.9706 0.999817 9.99999C0.999817 5.02943 5.02925 0.999992 9.99982 0.999992C14.9704 0.999992 18.9998 5.02943 18.9998 9.99999ZM9.99998 3.99999C10.2652 3.99999 10.5195 4.10535 10.7071 4.29288L14.7071 8.29288C15.0977 8.6834 15.0977 9.31657 14.7071 9.7071C14.3166 10.0976 13.6835 10.0976 13.2929 9.7071L10.9998 7.41402V15C10.9998 15.5523 10.5521 16 9.99982 16C9.44753 16 8.99982 15.5523 8.99982 15V7.41439L6.70714 9.7071C6.31662 10.0976 5.68345 10.0976 5.29293 9.7071C4.9024 9.31658 4.9024 8.68342 5.29292 8.29289L9.29287 4.29289C9.48041 4.10535 9.73476 3.99999 9.99998 3.99999Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM7.29289 9.29289L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289L16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071C16.3166 11.0976 15.6834 11.0976 15.2929 10.7071L13 8.41421V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V8.41421L8.70711 10.7071C8.31658 11.0976 7.68342 11.0976 7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16ZM15.9998 6C16.4203 5.99999 16.8215 6.17645 17.1056 6.48639L22.6058 12.4864C23.1656 13.0971 23.1243 14.0459 22.5137 14.6057C21.903 15.1655 20.9542 15.1243 20.3944 14.5136L17.5 11.3562V24.5C17.5 25.3284 16.8284 26 16 26C15.1716 26 14.5 25.3284 14.5 24.5V11.3562L11.6058 14.5136C11.046 15.1243 10.0972 15.1655 9.4865 14.6058C8.87581 14.046 8.83454 13.0971 9.39432 12.4864L14.8941 6.48643C15.1782 6.17648 15.5794 6.00001 15.9998 6Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;